import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  padding: 24px;
`
const Code = styled.code`
  color: crimson;
`

const Home = () => (
  <Container>
    <h1>Multimaxi - Infotram - v2</h1>
    <h2>Gebruik Multimaxi</h2>
    <div>
      Surf naar <Code>/realtime/:haltenummers/:aantal</Code> om het
      MultiMaxi-scherm te zien.
      <br />
      Bijvoorbeeld:
      <ul>
        <li>
          <Link to="/realtime/102113/5">/realtime/102113/5</Link>
        </li>
        <li>
          <Link to="/realtime/multimaxi/102113/5">
            /realtime/multimaxi/102113/5
          </Link>
        </li>
        <li>
          <Link to="/realtime/multimaxi-split/103734+103397+103377+102460">
            /realtime/multimaxi-split/103734+103397+103377+102460
          </Link>
        </li>
      </ul>
      <br />
      <b>Irtis</b>
      <br />
      Surf naar <Code>/realtime/irtis/:haltenummers/:aantal</Code> om het
      Irtis-scherm te zien.
      <br />
      Bijvoorbeeld:
      <ul>
        <li>
          <Link to="/realtime/irtis/102113/5">/realtime/irtis/102113/5</Link>
        </li>
      </ul>
    </div>
  </Container>
)

export default Home
